export default {
    getAllUsersManagers: env => {
        return {
            url: `/${env}/usersManagers`,
            method: 'GET'
        };
    },
    getUsersManagersByBrandId: (env, brandId) => {
        return {
            url: `/${env}/usersManagers/brandId/:brandId`,
            method: 'GET',
            route_params: {
                brandId
            }
        };
    },
    getUserManagerDetails: (env, userManagerId) => {
        return {
            url: `/${env}/usersManagers/:userManagerId`,
            method: 'GET',
            route_params: {
                userManagerId
            }
        };
    },
    resetPassword: (env, userManagerId) => {
        return {
            url: `/${env}/usersManagers/:userManagerId/resetPassword`,
            method: 'PATCH',
            route_params: {
                userManagerId
            }
        };
    },

    generateCode: (env, userManagerId) => {
        return {
            url: `/${env}/usersManagers/:userManagerId/generateCode`,
            method: 'PATCH',
            route_params: {
                userManagerId
            }
        };
    },

    updateUserManagerDetails: (env, userManagerId, form) => {
        let params = {};
        Object.keys(form).map(field => {
            if (form[field]) params[field] = form[field];
        });
        return {
            url: `/${env}/usersManagers/:userManagerId`,
            method: 'PATCH',
            route_params: {
                userManagerId
            },
            patch_params: params
        };
    },
    addUserManager: (env, userManagerForm) => {
        let params = {};
        Object.keys(userManagerForm).map(field => {
            if (userManagerForm[field]) params[field] = userManagerForm[field];
        });
        return {
            url: `/${env}/usersManagers/add`,
            method: 'POST',
            post_params: params
        };
    },
    deleteUserManager: (env, userManagerId) => {
        return {
            url: `/${env}/usersManagers/delete`,
            method: 'POST',
            post_params: {
                userManagerId
            }
        };
    }
};



// WEBPACK FOOTER //
// ./environments/genericEnv/data/UsersManagers/api.js